import React, { useContext, useEffect, useRef, useState } from 'react'
import "./Contact_us.css"
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { Col, Container, Form, Row } from "react-bootstrap";
import {
    faCircleXmark,
    faEnvelope,
    faLocationDot,
    faMapLocationDot,
    faPhone,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useLocation } from "react-router-dom";
import Common_heading from '../Common_Component/Common_heading/Common_heading';
import Successfullmodal from './successfullmodal/Successfullmodal';
import { Context } from '../../utils/context';
import { useForm, Controller } from "react-hook-form";
import classNames from "classnames";


export default function Contact_us() {

    const [modalShow, setModalShow] = useState(false);
    const { postData } = useContext(Context);
    const {
        control,
        register,
        handleSubmit,
        getValues,
        setValue,
        setError,
        clearErrors,
        formState: { errors },
        reset,
        trigger,
    } = useForm();

    const onSubmit = async (data) => {
        // console.log('Form Data:', data);
        data.type = 'web';
        const res = await postData(`/contactus`, data);
        if (res?.success) {
            setModalShow(true);
            reset();
            setTimeout(() => {
                setModalShow(false);
            }, 3000);
            console.log(res?.success + " adsaasdassss");
        }
        else {
            console.error('Error fetching  data:', res?.error);
        }
    }


    const location = useLocation();
    // Scroll to the top when the component mounts
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location]);

    const [phoneValue, setPhoneValue] = useState("");
    const [showMap, setShowMap] = useState(false);
    const mapRef = useRef(null);

    const toggleMap = () => {
        setShowMap(!showMap);
    };

    const handleClickOutside = (event) => {
        if (mapRef.current && !mapRef.current.contains(event.target)) {
            setShowMap(false);
        }
    };

    useEffect(() => {
        if (showMap) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [showMap]);
    return (
        <>
            <section className="Contact">
                <div className={`contact_section`}>
                    <Container>
                        <div className="contact_main">
                            <div className="heading-holder">
                                <Common_heading headingText={"Contact Us"} />
                            </div>
                            <div className="contact-form-holder">
                                <Row className="justify-content-center">
                                    <Col xxl={12} xl={12} lg={12} md={12} sm={12}>
                                        <div className="map-form-holder">
                                            <Row className="form-holder-contact me-0 ms-0">
                                                <Col
                                                    xxl={8}
                                                    xl={8}
                                                    lg={7}
                                                    md={6}
                                                    sm={12}
                                                    className="p-0"
                                                >
                                                    <div className="leftdivv">
                                                        <Form onSubmit={handleSubmit(onSubmit)}>
                                                            <Form.Group className="mb-4">
                                                                <Form.Control
                                                                    type="text"
                                                                    placeholder="Your Name"
                                                                    {...register('name', { required: 'Name is required' })}
                                                                    className={classNames('', { 'is-valid': getValues('name'), 'is-invalid': errors?.name })}
                                                                />
                                                                {errors?.name && <span className="invalid-feedback d-block">{errors.name.message}</span>}
                                                            </Form.Group>

                                                            <Form.Group className="mb-4">
                                                                <Form.Control
                                                                    type="text"
                                                                    placeholder="Email"
                                                                    {...register('email', {
                                                                        required: 'Email is required',
                                                                        pattern: {
                                                                            value: /^[^@]+@[^@]+\.[^@]+$/,
                                                                            message: 'Invalid email address',
                                                                        },
                                                                    })}
                                                                    className={classNames('', { 'is-valid': getValues('email'), 'is-invalid': errors?.email })}
                                                                />
                                                                {errors?.email && <span className="invalid-feedback d-block">{errors.email.message}</span>}
                                                            </Form.Group>

                                                            <Form.Group className="mb-4">
                                                                <Form.Control
                                                                    type="text"
                                                                    placeholder="Subject"
                                                                    {...register('subject', { required: 'Subject is required' })}
                                                                    className={classNames('', { 'is-valid': getValues('subject'), 'is-invalid': errors?.subject })}
                                                                />
                                                                {errors?.Subject && <span className="invalid-feedback d-block">{errors.subject.message}</span>}
                                                            </Form.Group>

                                                            <Form.Group className="mb-4">
                                                                <Controller
                                                                    name="contact_no"
                                                                    control={control}
                                                                    rules={{
                                                                        required: "Contact number is required",
                                                                        pattern: {
                                                                            value: /^\d{10}$/,
                                                                            message: "Number should be exactly 10 digits",
                                                                        },
                                                                    }}
                                                                    render={({ field }) => (
                                                                        <Form.Control
                                                                            type="text"
                                                                            {...field}
                                                                            className={classNames('', {
                                                                                'is-valid': getValues('contact_no') && !errors?.contact_no,
                                                                                'is-invalid': errors?.contact_no
                                                                            })}
                                                                            placeholder="Enter Mobile Number"
                                                                            maxLength={10}
                                                                            onChange={(e) => {
                                                                                const value = e.target.value.replace(/\D/g, ""); // Allow only digits
                                                                                field.onChange(value);
                                                                            }}
                                                                        />
                                                                    )}
                                                                />
                                                                {errors?.contact_no && (
                                                                    <span className="invalid-feedback d-block">
                                                                        {errors.contact_no.message}
                                                                    </span>
                                                                )}
                                                            </Form.Group>
                                                            <Form.Group className="mb-4">
                                                                <Form.Control
                                                                    as="textarea"
                                                                    rows={4}
                                                                    placeholder="Your message"
                                                                    {...register('message', { required: 'Message is required' })}
                                                                    className={classNames('', { 'is-valid': getValues('message'), 'is-invalid': errors?.message })}
                                                                />
                                                                {errors?.message && <span className="invalid-feedback d-block">{errors.message.message}</span>}
                                                            </Form.Group>
                                                            <div className="btndiv">
                                                                <button type="submit" className="btnnnn">
                                                                    Send Message
                                                                </button>
                                                            </div>
                                                        </Form>
                                                    </div>
                                                </Col>
                                                <Col
                                                    xxl={4}
                                                    xl={4}
                                                    lg={5}
                                                    md={6}
                                                    sm={12}
                                                    className="p-0"
                                                >
                                                    <div className="leftdivv1">
                                                        <div className="d-flex align-items-center side-section">
                                                            <div>
                                                                <div className="fonticndiv">
                                                                    <FontAwesomeIcon icon={faPhone} />
                                                                </div>
                                                            </div>
                                                            <p className="cont_text mb-0 ms-2">7668201518</p>
                                                        </div>
                                                        <div className="d-flex align-items-center side-section">
                                                            <div>
                                                                <div className="fonticndiv">
                                                                    <FontAwesomeIcon icon={faEnvelope} />
                                                                </div>
                                                            </div>
                                                            <p className="cont_text mb-0 ms-2">
                                                                absarmoney@gmail.com
                                                            </p>
                                                        </div>
                                                        <div className="d-flex align-items-center side-section">
                                                            <div>
                                                                <div className="fonticndiv">
                                                                    <FontAwesomeIcon icon={faLocationDot} />
                                                                </div>
                                                            </div>
                                                            <p className="cont_text mb-0 ms-2">
                                                                104 ashok nagar Ashok nagar etawah 206001
                                                            </p>
                                                        </div>
                                                        <div className="d-flex align-items-center side-section">
                                                            <div>
                                                                <div className="fonticndiv">
                                                                    <FontAwesomeIcon icon={faMapLocationDot} />
                                                                </div>
                                                            </div>
                                                            <p
                                                                className="cont_text mb-0 ms-2 cursor-pointer"
                                                                onClick={toggleMap}
                                                            >
                                                                Find Us on map
                                                            </p>
                                                        </div>
                                                    </div>
                                                </Col>
                                            </Row>

                                            {showMap && (
                                                <div className="close-btn" onClick={() => setShowMap(false)}>
                                                    <FontAwesomeIcon icon={faCircleXmark} />
                                                </div>
                                            )}

                                            <div
                                                ref={mapRef}
                                                className={`gmap_canvas swing-top-fwd ${showMap ? "show" : ""
                                                    }`}
                                            >
                                                <iframe
                                                    className="gmap_iframe"
                                                    frameBorder="0"
                                                    scrolling="no"
                                                    marginHeight="0"
                                                    marginWidth="0"
                                                    src="https://maps.google.com/maps?width=600&amp;height=400&amp;hl=en&amp;q=104 ashok nagar Ashok nagar etawah 206001&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
                                                ></iframe>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </Container>
                </div>
            </section>

            <Successfullmodal
                show={modalShow}
                onHide={() => setModalShow(false)}
                message={"Message sent successfully"}
            />
        </>
    )
}
